var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Telegram_svg__a)",
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.527 9.894a476 476 0 0 1 5.831-2.512c2.778-1.155 3.355-1.355 3.73-1.362.083-.001.268.02.388.116a.42.42 0 0 1 .142.271c.014.078.03.255.017.394-.15 1.581-.801 5.418-1.133 7.19-.14.749-.416 1-.683 1.024-.58.054-1.022-.383-1.584-.752-.88-.577-1.378-.936-2.232-1.499-.987-.65-.347-1.008.215-1.593.148-.153 2.706-2.48 2.756-2.691.006-.026.012-.125-.047-.177s-.144-.034-.207-.02q-.132.03-4.218 2.788-.598.411-1.084.4c-.357-.007-1.044-.201-1.555-.367-.626-.204-1.124-.311-1.08-.657q.033-.27.744-.553",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Telegram_svg__a",
    x1: 10,
    x2: 10,
    y1: 0,
    y2: 19.852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
};
export default SvgTelegram;